import React from "react";
import { Layout, Card } from 'antd';
import WebsiteIndexEntryTabs from '../../deepAnalysis/websiteIndexEntry/WebsiteIndexEntryTabs';
import useGetCurrentWebsite from "../../deepAnalysis/websiteIndexEntry/hooks/useGetCurrentWebsite";
import DomainContentAnalysis from "../contentAnalysis/ContentAnalysis";
import useGetPlanSettings from "../../sales/hooks/useGetPlanSettings";
import LoadingIndicator from "../../components/shared/LoadingIndicator/LoadingIndicator";
import DisabledFeature from "../../shared/DisabledFeature";

const { Content } = Layout;


export default function AIContentAnalysisPage() {
    const { website: selectedWebsite } = useGetCurrentWebsite();
    const domain = selectedWebsite?.domain || "";
    const { allowAIContentAnalysis, isLoading: isLoadingPlanSettings } = useGetPlanSettings();

    return (
        <Content className="general-layout-content">
            {isLoadingPlanSettings && <LoadingIndicator />}
            {!isLoadingPlanSettings && allowAIContentAnalysis === false && (
                <Card className="ai-content-analysis-no-access-card">
                    <DisabledFeature />
                </Card>
            )}
            {(!isLoadingPlanSettings && allowAIContentAnalysis === true) && (
                <WebsiteIndexEntryTabs>
                    {domain ? <DomainContentAnalysis domain={domain} /> : null}
                </WebsiteIndexEntryTabs>
            )}
        </Content>
    );
}